exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@use 'sass:map';.no-scroll[data-v-2f1db0d8]{position:relative;z-index:100;overflow:hidden}.landing-page[data-v-2f1db0d8]{display:flex;flex-direction:column;align-items:center;position:absolute;top:0;left:0;width:100%;padding-top:40px;background:#fff}\n", ""]);
